var NearestManager = {
	previewNode:null,
	opened:false,
	ID:"",
	json:null,
	hasResizing:false,
	pos:0,
	see:0,
	loaded:0,
	limit:0,
	excluded:{},
	menuButton:"#menubar_nearest",
	
	init: function() {
		$("#panels").append($("<div id='nearest'></div>"));
		AppEvent.on(player, "afterLoad", NearestManager.afterLoad);

		SpeechManager.prepareTip("PLAYER.OPEN_PREVIEW", "TIPS");
	},
	
	afterLoad: function(data) {		
		NearestManager.ID = data.place_id;		
		ssi("nearest","enabled",{"id":data.place_id},function(resp) {
			/*
			if (resp.data == "1") {
				$("#nearest_button").show();
			} else {
				$("#nearest_button").hide();					
			}
			*/
		});		
	},

	enlargeIt: function(self, event) {
		var me = $(self);
		
		$("#thumb_" + me.attr("data-pid")).attr("src", me.attr("data-image"));
		$("#galleries_" + me.attr("data-pid") + " img").css("border", "1px solid #ffffff");
		me.find("img").css("border", "3px solid #ffffff");
		//$("#nurl_" + me.attr("data-pid")).attr("href",me.attr("data-url"));
	},
	
	resizing: function() {
			NearestManager.fill(0);
			$("#nearest").css("height",($(window).height() - 50) + "px");
	},
	
	close: function() {
		$("#nearest").hide();
	},
		
	show: function() {
		
		SpeechManager.speakTip("PLAYER.OPEN_PREVIEW", "TIPS");

		menubar.setActive(this);

		player.preload(1);
		
		$("#nearest").show();
		$("#nearest").html("");
			
		$("#nearest").css("height",($(window).height() - 50) + "px");
			
		NearestManager.opened = !NearestManager.opened;
			
		if (NearestManager.opened)
			ssi("nearest","view",{"id":NearestManager.ID, "view": "mobile"},function(resp) {

				NearestManager.json = resp;					
				NearestManager.fill(0);				
				player.preload(0);
					
			});
		else {			
			player.preload(0);
			NearestManager.fill(0);
		}
	},
		
		
	invertTag: function(self, tg) {
		var tag = $(self);
		var allup = true;
		var down = 0;
		var allcnt = 0;
			
		if (tag.hasClass("tagged")) {				
			
			for(var og in NearestManager.json.data.tags) {
				if (NearestManager.excluded[og] == 1) {allup = false; down ++;}
				allcnt ++;
			}
				
			if (allup) { 
				for(var og in NearestManager.json.data.tags) {
					if (og != tg) NearestManager.excluded[og] = 1;
				}					
			//} else if (down == allcnt - 1) {
			} else {
				for(var pn in NearestManager.excluded) delete NearestManager.excluded[pn];
				//NearestManager.excluded[tg] = 1;
				//NearestManager.excluded[tg] = 1;
			}
			
		} else {
			delete NearestManager.excluded[tg];
		}
		
		$(self).toggleClass("tagged");
		
		NearestManager.fill(0);
	},
		
	toggleTag: function(self, tg) {
		var tag = $(self);
		var allup = true;
		var down = 0;
		var allcnt = 0;
						
		if (tag.hasClass("tagged")) {								
			NearestManager.excluded[tg] = 1;				
		} else {
			delete NearestManager.excluded[tg];
		}
			
		$(self).toggleClass("tagged");
			
		NearestManager.fill(1);
	},
		
	toggleAllTag: function(self) {
		var tag = $(self);
			
		if (tag.hasClass("tagged")) {
			for(var tg in NearestManager.json.data.tags) {
				NearestManager.excluded[tg] = 1;
			}
		} else {
			for(var pn in NearestManager.excluded) delete NearestManager.excluded[pn];
		}
		
		NearestManager.fill(0);
	},
		
	isExcluded: function(rc) {
		if (NearestManager.excluded[NearestManager.json.data.tagged[rc][0]] != undefined
			&& (NearestManager.json.data.tagged[rc].length <= 1 || NearestManager.excluded[NearestManager.json.data.tagged[rc][1]] != undefined) 
			&& (NearestManager.json.data.tagged[rc].length <= 2 || NearestManager.excluded[NearestManager.json.data.tagged[rc][2]] != undefined) 
			) return true;
		
		return false;
	},
		
	countItems: function() {
		var no = 0;
			
		for(var rc in NearestManager.json.data.items) {
			if (NearestManager.isExcluded(rc)) continue;
			no ++;
		}
			
		return no;
	},
		
	more: function() {
		var data = "";
		var no = 0;
		var cnt = 0;


		for(var rc in NearestManager.json.data.items) {
			cnt ++;

			if (cnt - 1 <= NearestManager.loaded) continue;

			if (no > 6)  {
				break;
			}

			if (NearestManager.isExcluded(rc)) continue;
			
			data += NearestManager.json.data.items[rc];
			NearestManager.loaded = cnt - 1;

			no ++;
		}

		$(data).insertBefore("#nearest_more");
	},

	fill: function(s) {
		var data = "";
		var sw = $(window).width();
			
		NearestManager.pos = 0;
			
		NearestManager.loaded = 0;

		data = NearestManager.json.data.start;
									
		data += "<div style='float:left' class='' id='nearestPlaces'>";
		var no = 0;
			
		for(var rc in NearestManager.json.data.items) {
			if (no > 6)  {
				data += "<div id='nearest_more' onclick='NearestManager.more();'><div class='more'>...</div></div>";
				break;
			}

			if (NearestManager.isExcluded(rc)) continue;
			
			data += NearestManager.json.data.items[rc];
			NearestManager.loaded = no;

			no ++;
		}
						
		if (no == 0) data += "<h3 style='padding-top:130px;padding-bottom:130px;'>Nie znaleziono obiektów w wybranych przez Ciebie kategoriach.</h3>";			
		data += "<div style='width:100%;height:100px;position:relative;float:left;'></div></div>";
			
		NearestManager.see = no - s;
		if (no - s > NearestManager.limit) NearestManager.limit = no - s;
									
		var tags = "";
		var seeall = true;
		var selected = [];
		var tagcount = 0;
		for(var tg in NearestManager.json.data.tags) {
			var excl = "tagged";
			if (NearestManager.excluded[tg] != undefined) {excl = ""; seeall = false;}
			tagcount += NearestManager.json.data.tags[tg];
			if (excl == "tagged") selected.push(tg);
			tags += "<div class='tag'><a href='javascript:void(null);' class='left " + excl + "' data-tag='" + tg + "' onclick='NearestManager.invertTag(this, \"" + tg + "\");'>" + tg + " <span class='tagcount'>[" + NearestManager.json.data.tags[tg] + "]</span></a>";
			tags += (excl != ""?
					" <a href='javascript:void(null);' class='right " + excl + "' data-tag='" + tg + "' onclick='NearestManager.toggleTag(this, \"" + tg + "\");'>" +
					"<div style='position:absolute;right:5px;top:5px;border:1px solid #415171;padding:5px;'>&#10003;</div></a>"
				:
					" <a href='javascript:void(null);' class='right " + excl + "' data-tag='" + tg + "' onclick='NearestManager.toggleTag(this, \"" + tg + "\");'>" +
					"<div style='position:absolute;right:5px;top:5px;border:1px solid #113141;padding:5px;width:13px;height:18px;'>&nbsp;</div></a>")
				+ "<div class='clear'></div></div><div class='clear'></div>";
		}
						
		var alltags = "<div class='tag'><a href='javascript:void(null);' class='left " + (seeall?"tagged":"") + "' data-tag='" + (seeall?"Ukryj wszystkie":"Pokaż wszystkie") + "' onclick='NearestManager.toggleAllTag(this);'>" + (seeall?"Ukryj wszystkie":"Pokaż wszystkie") + " <span class='tagcount'>[" + tagcount + "]</span>" + 
		(seeall?
		"<div style='position:absolute;right:5px;top:5px;border:1px solid #415171;padding:5px;'>&#10003;</div></a>"
		:
		"<div style='position:absolute;right:5px;top:5px;border:1px solid #113141;padding:5px;width:13px;height:18px;'>&nbsp;</div>") +
		"<div class='clear'></div></div><div class='clear'></div>";
		
		data += NearestManager.json.data.end;
			
		if (s == 0) {			
//			$("#nearest").html("<div class='inner' id='nearest_inner'>" + data + "</div>" + "<div id='neartags' style='padding-right:10px;'><a href='javascript:void(null);' class='menu' onclick='NearestManager.toggleCategoryMenu();' style='position:absolute;right:20px;text-align:right;'>Wszystkie kategorie <img src='assets/dropdown.png' width='15'></a></div><div id='neartags_taglist'><div style='background-color:#000000;position:fixed;right:0px;top:0px;'><a href='javascript:void(null);' onclick='$(\"#neartags_taglist\").toggle();'>Zamknij listę &times;</a></div>" + alltags + tags + "</div><div id='select_route'>Jaką trasę chcesz wyznaczyć:<br><br><a href='javascript:void(null);' onclick='NearestManager.routeFromHome();' id='from_home'>Z mojej lokalizacji</a><a href='javascript:void(null);' onclick='NearestManager.routeFromPano();' id='from_pano'>Z teraz oglądanej panoramy</a><Br><a href='javascript:void(null)' ontouchend='$(\"#select_route\").hide();' style='background-color:transparent;border:0px;position:absolute;bottom:30px;margin:0;padding:0;width:100%;'><img src='assets/back.png' width='100'></a></div>");
			$("#nearest").html(TPL.render("nearest-main", { data:data, alltags: alltags + tags}));
			
			if (seeall)
				$("#neartags .menu").html("Wszystkie kategorie <img src='assets/dropdown.png' width='15'>");
			else if (selected.length == 1)
				$("#neartags .menu").html(selected[0] + " <img src='assets/dropdown.png' width='15'>");
			else if (selected.length == 2)
				$("#neartags .menu").html(selected[0] + " i " + selected[1] + " <img src='assets/dropdown.png' width='15'>");
			else 
				$("#neartags .menu").html(selected[0] + " i " + (selected.length - 1) + " " + (selected.length - 1 < 5?"inne":"innych") + " <img src='assets/dropdown.png' width='15'>");
		} else {
			$("#nearest_inner").html(data);
			$("#neartags_taglist").html(alltags + tags);
		}
			
	},
				
	toggleCategoryMenu: function() {
		$("#neartags_taglist").toggle();
		if ($("#neartags .menu").html() == "Zamknij menu") {
			NearestManager.fill(0);
			//$("#neartags .menu").html("Wszystkie kategorie <img src='assets/dropdown.png' width='15");
		} else {
			$("#neartags .menu").html("Zamknij menu");
		}
	},
	
	openRoute: function(slat, slng, lat, lng) {
		this.lat = lat;
		this.lng = lng;
		this.slat = slat;
		this.slng = slng;
		$("#select_route").show();
		//$("#from_pano").attr("href","https://www.google.com/maps?saddr=" + this.slat + "," + this.slng + "&daddr=" + this.lat + "," + this.lng);
	},
	
	routeFromHome: function() {
		mapInfo.openRouteMap(this.lat, this.lng);
		/*
		if (navigator.geolocation) {
			navigator.geolocation.getCurrentPosition(NearestManager.showPosition, NearestManager.geoError);
		} else {
			alert("Niestety Twoja przeglądarka nie wspiera lokalizacji, nie możesz skorzystać z tej opcji.");
		}
		*/
	},
	
	geoError: function(error) {
		var msg = "";
		switch(error.code) {
			case error.PERMISSION_DENIED:
				msg = "Nie przyznano dostepu do geolokalizacji dla tej strony. Sprawdź ustawienia przeglądarki."
				break;
			case error.POSITION_UNAVAILABLE:
				msg = "Dane o lokalizacji są niedostępne w tym momencie."
				break;
			case error.TIMEOUT:
				msg = "Nie udało się pobrać danych o geolokalizacji (TIMEOUT)."
				break;
			case error.UNKNOWN_ERROR:
				msg = "Wystąpił nieznany błąd."
				break;
		}
		
		alert(msg);
	},
	
	showPosition: function(position) {
		mapInfo.openRouteMap(this.lat, this.lng);
		//document.location = "https://www.google.com/maps?saddr=" + position.coords.latitude + "," + position.coords.longitude + "&daddr=" + NearestManager.lat + "," + NearestManager.lng;
		//alert(position.coords.latitude + "," + position.coords.longitude);
		//window.open("http://maps.google.com/maps?saddr=" + position.coords.latitude + "," + position.coords.longitude + "&daddr=" + NearestManager.lat + "," + NearestManager.lng + "&ll=", "_blank");
	},
	
	routeFromPano: function() {
		window.open("http://maps.google.com/maps?saddr=" + this.slat + "," + this.slng + "&daddr=" + NearestManager.lat + "," + NearestManager.lng + "&ll=", "_blank");
		//document.location = "https://www.google.com/maps?saddr=" + this.slat + "," + this.slng + "&daddr=" + this.lat + "," + this.lng;
		//https://www.google.com/maps?saddr=".$lat.",".$lng."&daddr=".$row['pn_lat'].",".$row['pn_lng']."
	}
}

PluginManager.add(NearestManager);